const el = {
    nav: {
      home: "Αρχική",
      browse: "Εξερεύνηση Γάμων",
      dashboard: "Πίνακας Ελέγχου",
      messages: "Μηνύματα",
      profile: "Προφίλ",
      login: "Σύνδεση",
      register: "Εγγραφή",
      logout: "Αποσύνδεση",
      admin: "Διαχειριστής",
      faq: "Συχνές Ερωτήσεις",
      about: "Σχετικά",
      contact: "Επικοινωνία",
      pricing: "Τιμολόγηση",
      howItWorks: "Πώς Λειτουργεί",
    },
    auth: {
      login: {
        title: "Καλώς ήρθατε πίσω",
        email: "Email",
        password: "Κωδικός",
        button: "Σύνδεση",
        noAccount: "Δεν έχετε λογαριασμό;",
        register: "Εγγραφείτε τώρα",
      },
      register: {
        title: "Δημιουργία Λογαριασμού",
        name: "Πλήρες Όνομα",
        email: "Email",
        password: "Κωδικός",
        role: "Θέλω να...",
        roleHost: "Διοργανώσω γάμο",
        roleGuest: "Παρευρεθώ σε γάμους",
        terms: "Αποδέχομαι τους όρους και την πολιτική απορρήτου",
        button: "Εγγραφή",
        hasAccount: "Έχετε ήδη λογαριασμό;",
        login: "Συνδεθείτε τώρα",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Φόρτωση...",
      error: "Παρουσιάστηκε σφάλμα",
      success: "Επιτυχία",
      save: "Αποθήκευση",
      cancel: "Ακύρωση",
      delete: "Διαγραφή",
      edit: "Επεξεργασία",
      back: "Πίσω",
      next: "Επόμενο",
      language: "Γλώσσα",
      currency: "Νόμισμα",
      search: "Αναζήτηση",
      filter: "Φίλτρο",
      all: "Όλα",
      none: "Κανένα",
      yes: "Ναι",
      no: "Όχι",
    },
    footer: {
      about: "Σχετικά",
      privacy: "Απόρρητο",
      terms: "Όροι",
      contact: "Επικοινωνία",
      copyright: "© 2024 WEDVAYA. Με επιφύλαξη παντός δικαιώματος.",
    },
  };

export default el;
